export default "<!-- <app-sidebar ></app-sidebar> -->\r\n\r\n\r\n<app-sidebar  [navStatus]=\"nav.visible\"></app-sidebar>\r\n"